import { render, staticRenderFns } from "./Dpo.vue?vue&type=template&id=53c0c900&scoped=true&"
import script from "./Dpo.vue?vue&type=script&lang=js&"
export * from "./Dpo.vue?vue&type=script&lang=js&"
import style0 from "./Dpo.vue?vue&type=style&index=0&id=53c0c900&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c0c900",
  null
  
)

export default component.exports